import * as React from 'react';

const IconThumbsUp = (props) => (
    <svg
        {...props}
        fill='none'
        height={48}
        viewBox='0 0 30 31'
        width={48}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M11.6063 0.729741C11.8098 0.285123 12.2539 0 12.7429 0H13.4748C16.6067 0 19.042 2.72462 18.6919 5.83692L17.9985 12H25.2961C27.7559 12 29.75 13.9941 29.75 16.4539C29.75 17.682 29.2429 18.8556 28.3486 19.6973L28.25 19.7901V22.3611C28.25 23.2086 27.9751 24.0331 27.4667 24.7111L27.25 25V27.0833C27.25 29.2465 25.4964 31 23.3333 31H11.6944C11.1355 31 10.5916 30.8187 10.1444 30.4833L6.85556 28.0167C6.84113 28.0058 6.82359 28 6.80556 28H2.83333C1.4066 28 0.25 26.8434 0.25 25.4167V17.9467C0.25 17.101 0.66389 16.3089 1.35808 15.826L6.25564 12.419L11.6063 0.729741ZM13.545 2.50087L8.38659 13.7703C8.29348 13.9737 8.14748 14.1484 7.96383 14.2761L2.78575 17.8783C2.76335 17.8939 2.75 17.9194 2.75 17.9467V25.4167C2.75 25.4627 2.78731 25.5 2.83333 25.5H6.80556C7.36451 25.5 7.90839 25.6813 8.35556 26.0167L11.6444 28.4833C11.6589 28.4942 11.6764 28.5 11.6944 28.5H23.3333C24.1157 28.5 24.75 27.8657 24.75 27.0833V24.1667L25.4667 23.2111C25.6506 22.9659 25.75 22.6676 25.75 22.3611V18.7099L26.6352 17.8768C27.0275 17.5075 27.25 16.9927 27.25 16.4539C27.25 15.3748 26.3752 14.5 25.2961 14.5H15.2015L16.2075 5.55744C16.3883 3.95052 15.1515 2.54091 13.545 2.50087Z'
            fill='currentColor'/>
    </svg>
);

export default IconThumbsUp;
